import { render, staticRenderFns } from "./CardNews.vue?vue&type=template&id=510d4d82"
import script from "./CardNews.vue?vue&type=script&lang=js"
export * from "./CardNews.vue?vue&type=script&lang=js"
import style0 from "./CardNews.vue?vue&type=style&index=0&id=510d4d82&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports